/** Identifiant d'une option, que le champ désigne par `aria-activedescendant` (#109). */
export function optionId(listboxId: string, index: number): string {
  return `${listboxId}-${index}`
}
